<template>
  <div class="row living-options">
    <card-tabs 
      class="w-100" 
      :tabs="['masterplan', 'subsections', 'properties', 'propertyModels']"
      :active-tab="activeTab"
      @tabClick="navigateToTab"
    >
      <template v-slot:masterplan>
        <LivingOptionsMasterplan></LivingOptionsMasterplan>
      </template>
      <template v-slot:subsections>
        <LivingOptionsSubsections></LivingOptionsSubsections>
      </template>
      <template v-slot:properties>
        <LivingOptionsProperties></LivingOptionsProperties>
      </template>
      <template v-slot:propertyModels>
        <LivingOptionsPropertyModels></LivingOptionsPropertyModels>
      </template>
    </card-tabs>   
  </div>
</template>
<script>
import { camelCase } from 'lodash'
import CardTabs from '@/components/Cards/TabsCard'
import LivingOptionsMasterplan from './LivingOptionsMasterplan'
import LivingOptionsProperties from './LivingOptionsProperties'
import LivingOptionsPropertyModels from './LivingOptionsPropertyModels'
import LivingOptionsSubsections from './LivingOptionsSubsections'

export default {
  components: { CardTabs, LivingOptionsMasterplan, LivingOptionsProperties, LivingOptionsPropertyModels, LivingOptionsSubsections },

  computed: {
    activeTab () {
      return camelCase(this.$route.name)
    }
  },

  beforeRouteEnter(to, from, next) {
    if (to.path === '/live') {
      next('/live/masterplan')
    } else {
      next()
    }
  },

  beforeRouteUpdate (to, from, next) {
    if (to.path === '/live') {
      next('/live/masterplan')
    } else {
      next()
    }
  },

  methods: {
    navigateToTab (tab) {
      this.$router.push('/live/' + tab)
    }
  }
}
</script>
<style lang="scss">

.tag-crm {
  background: #60f454;
  border: 1px solid darken(#60f454, 15%);
  border-radius: 3px;
  display: inline-block;
  font-size: 11px;
  margin: 0 8px 0 0;
  padding: 2px 8px;
}

.dot {
  background: #b8b8b8;
  border: 1px solid darken(#b8b8b8, 15%);
  border-radius: 50%;
  display: inline-block;
  height: 10px;
  margin-right: 6px;
  width: 10px;

  &--crm {
    background: #60f454;
    border: 1px solid darken(#60f454, 15%);
  }
}
</style>